import { h, defineComponent, SetupContext } from 'vue';
// @ts-ignore
import { BModal } from 'buefy/dist/esm/modal';
import { Icon } from '@/ui/components/icon/Icon';
import { box } from '@/ui/components/Box';

type CanCancel = 'escape' | 'x' | 'outside';

export const modalProps = [
  'active', 'trapFocus', 'destroyOnHide', 'ariaRole', 'ariaModal',
  'customClass', 'width', 'canCancel', 'hideClose', 'hasPrimaryBackgroundColor', 'fullScreen',
];

export interface ModalProps {
  active: boolean;
  trapFocus?: boolean;
  destroyOnHide?: boolean;
  ariaRole?: 'dialog' | 'alertdialog';
  ariaModal?: boolean;
  customClass?: string;
  width?: string | number;
  hideClose?: boolean;
  canCancel?: CanCancel[];
  hasPrimaryBackgroundColor?: string;
  fullscreen?: boolean;
}

export const Modal = defineComponent<ModalProps>({
  name: 'Modal',
  props: modalProps,
  setup(props, context: SetupContext) {
    return function render() {
      return h(BModal, {
        props,
        on: {
          close: () => {
            context.emit('close');
          },
        },
      }, [
        box([
          h('div', { class: 'modal__content' }, [
            !props.hideClose && h(Icon, {
              props: {
                icon: 'times',
                classes: 'modal__close',
              },
              nativeOn: {
                click: () => {
                  context.emit('close');
                },
              },
            }),
            context.slots.title ? h('h5', { class: 'title is-5' }, context.slots.title()) : undefined,
            context.slots.default?.(),
          ]),
          context.slots.actions ? h('div', { class: 'modal__actions' }, context.slots.actions()) : undefined,
        ], { class: { 'modal__content--has-primary-background': props.hasPrimaryBackgroundColor } }),
      ]);
    };
  },
});
